import { useSelector } from 'react-redux';
import { ContainerInner } from 'shared/components/ContainerInner';
import { SeoCrossLinks } from '../../components/SeoCrossLinks';
import { selectSeoCrossLinks } from '../../selectors/landing';

export type TSeoCrossLinksVariant = 'default' | 'redesign';

interface ISeoCrossLinksContainerProps {
  variant?: TSeoCrossLinksVariant;
}

export function SeoCrossLinksContainer({ variant = 'default' }: ISeoCrossLinksContainerProps) {
  const seoBlocks = useSelector(selectSeoCrossLinks);

  if (seoBlocks.length === 0) {
    return null;
  }

  const content = <SeoCrossLinks seoBlocks={seoBlocks} variant={variant} />;

  if (variant === 'redesign') {
    return <ContainerInner>{content}</ContainerInner>;
  }

  return content;
}
